module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image5-ba0a5c806b75e4ae2eab3ce1c8a78839.jpg";